import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import ModalLoading from "../components/ModalLoading";
import AccountDetailsFragment from "../fragment/register/AccountDetailsFragment";
import Footer from "../components/Footer";
import OutletDetailsFragment from "../fragment/register/OutletDetailsFragment";
import UserDetailsFragment from "../fragment/register/UserDetailsFragment";
import BankDetailsFragment from "../fragment/register/BankDetailsFragment";
import PolicyAgreementFragment from "../fragment/register/PolicyAgreementFragment";
import PinSetupFragment from "../fragment/register/PinSetupFragment";
import ButtonRequire from "../components/Button/ButtonRequire";

export default function Register() {
  const [fragment, setFragment] = useState("account-details");
  const [fragmentHistory, setFragmentHistory] = useState(["account-details"]);
  const [showModalLoading, setShowModalLoading] = useState(false);
  // navigate
  const { state } = useLocation();
  const { user, outlet, channel } = state ?? {};

  useEffect(() => {
    if (
      fragment !== "account-details" &&
      fragmentHistory[fragmentHistory.length - 1] !== fragment
    ) {
      setFragmentHistory([...fragmentHistory, fragment]);
    }
  }, [fragment]);

  return (
    <div className="relative space-y-10 h-screen mb-12">
      {/* Modal Loading */}
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      {/* Pages Register */}
      <div>
        <Header
          title="Register"
          disableBack={fragment === "account-details"}
          fragmentHistory={fragmentHistory}
          setFragmentHistory={setFragmentHistory}
          isUsingFragment={true}
          setFragment={setFragment}
        />
        <div className="px-4 pt-8 pb-12 bg-white">
          <div className="space-y-5">
            {fragment === "account-details" ? (
              <>
                <AccountDetailsFragment dataUser={user} dataChannel={channel} />
                <ButtonRequire
                  title="Next"
                  functionState={() => setFragment("outlet-details")}
                  isDisabled={false}
                />
              </>
            ) : fragment === "outlet-details" ? (
              <>
                <OutletDetailsFragment dataOutlet={outlet} />
                <ButtonRequire
                  title="Next"
                  functionState={() => setFragment("user-details")}
                  isDisabled={false}
                />
              </>
            ) : fragment === "user-details" ? (
              <>
                <UserDetailsFragment dataUser={user} dataOutlet={outlet} />
                <ButtonRequire
                  title="Next"
                  functionState={() => setFragment("bank-details")}
                  isDisabled={false}
                />
              </>
            ) : fragment === "bank-details" ? (
              <>
                <BankDetailsFragment
                  dataUser={user}
                  dataOutlet={outlet}
                  setFragment={setFragment}
                />
              </>
            ) : fragment === "pin-setup" ? (
              <>
                <PinSetupFragment dataUser={user} setFragment={setFragment} />
              </>
            ) : fragment === "policy-agreement" ? (
              <>
                <PolicyAgreementFragment
                  dataUser={user}
                  dataOutlet={outlet}
                  dataChannel={channel}
                />
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="fixed bottom-0 pb-3">
          <Footer color="gray-400" />
        </div>
      </div>
    </div>
  );
}
